/**
 *  HeaderLinks.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system 
import React, { Component } from "react";

// template
import { NavItem, Nav } from "react-bootstrap";

// redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearAccount } from '../../actions/account';
import { clearUsers } from '../../actions/users';

// global
var firebase = require("../../firebase");

class HeaderLinks extends Component {
  
  logout = () => {
    const { history } = this.props;

    firebase.auth.signOut().then(() => {
      this.clearAll();
      history.push('/login');
    });
  }

  clearAll = () => {
    const { clearAccount, clearUSers } = this.props;
    
    clearUsers();
    clearAccount();
  }

  render() {
    const { account } = this.props;

    return (
      <div>
        <Nav pullRight>
          <NavItem eventKey={1} href="#">Olá, {account.personalData.name ? account.personalData.name : "Usuário Desconhecido"}</NavItem>
          <NavItem eventKey={3} href="" onClick={this.logout}>Sair</NavItem>
        </Nav>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  account: store.account.account
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ clearAccount, clearUsers}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx